import { MentorPerformanceOverview } from "@/components/mentor-performance";
import { requirePermission } from "@/lib/casl/route-guards";
import { mentorMetricsSearchSchema } from "@/lib/hooks/mentor-performance/use-mentor-metrics-params";
import { useFeatureFlagEnabled } from "@posthog/react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/_authenticated/mentor-performance/")({
  component: MentorPerformancePage,
  validateSearch: mentorMetricsSearchSchema,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "mentor-metrics-dashboard");
  },
});

function MentorPerformancePage() {
  const featureFlag = useFeatureFlagEnabled("enable-mentor-performance");

  if (!import.meta.env.DEV && featureFlag === undefined) {
    return (
      <div
        role="status"
        className="flex min-h-screen items-center justify-center bg-surfaces-z3"
      >
        <Loader2 className="size-8 animate-spin text-blue-brand" aria-hidden />
        <span className="sr-only">Loading mentor performance</span>
      </div>
    );
  }

  if (!import.meta.env.DEV && featureFlag === false) {
    return <Navigate to="/" replace />;
  }

  return <MentorPerformanceOverview />;
}
